import React from 'react';
interface AutoBrokerSectionProps {
  language: 'en' | 'es';
}
export function AutoBrokerSection({
  language
}: AutoBrokerSectionProps) {
  const badges = language === 'en' ? ['Special Financing Available', 'All Credit Welcome', 'No SSN Required'] : ['Financiamiento Especial Disponible', 'Todo Crédito Bienvenido', 'No Se Requiere SSN'];
  const brands = [{
    name: 'KIA',
    models: ['Sorento', 'Telluride', 'Sportage', 'K5', 'Soul', 'Carnival']
  }, {
    name: 'TOYOTA',
    models: ['Camry', 'Corolla', 'RAV4', 'Highlander', 'Tacoma', 'Sienna']
  }];
  return <section className="py-24 bg-luxury-alt relative" data-id="element-2">
      {/* Decorative elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-px h-24 bg-gradient-to-b from-gold-primary/50 to-transparent" data-id="element-3" />
      <div className="absolute top-24 left-1/2 -translate-x-1/2 text-gold-primary/50 text-xs" data-id="element-4">
        ◆
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12" data-id="element-5">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-6">
          <h2 className="font-sans text-sm font-bold text-gold-light tracking-[0.2em] uppercase mb-4" data-id="element-7">
            {language === 'en' ? 'AUTO BROKER SERVICE' : 'SERVICIO DE AUTO BROKER'}
          </h2>
          <h3 className="font-serif text-4xl md:text-5xl text-warm-white mb-6 leading-tight" data-id="element-8">
            {language === 'en' ? 'Your New Car, No Stress' : 'Tu Auto Nuevo, Sin Complicaciones'}
          </h3>
          <p className="text-warm-gray text-lg" data-id="element-9">
            {language === 'en' ? 'We find it. We negotiate it. You drive it.' : 'Lo encontramos. Lo negociamos. Tú lo manejas.'}
          </p>
        </div>

        {/* Badge Pills */}
        <div className="flex flex-wrap justify-center gap-3 mb-16" data-id="element-10">
          {badges.map((badge, index) => <span key={index} className="px-5 py-2 border border-gold-dark/40 rounded-full text-gold-light text-sm font-medium tracking-wide" data-id="element-11">
              {badge}
            </span>)}
        </div>

        {/* Brand Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12 max-w-5xl mx-auto mb-16" data-id="element-12">
          {brands.map(brand => <div key={brand.name} className="group relative bg-luxury-card rounded-2xl p-1 transition-all duration-500 hover:shadow-gold-glow" data-id="element-13">
              {/* Subtle gold gradient top border effect */}
              <div className="absolute top-0 left-0 right-0 h-1 bg-gold-gradient rounded-t-2xl opacity-80" data-id="element-14" />

              <div className="bg-luxury-card h-full rounded-xl p-8 sm:p-10 border border-gold-dark/20 relative overflow-hidden" data-id="element-15">
                {/* Background glow on hover */}
                <div className="absolute -top-24 -right-24 w-48 h-48 bg-gold-primary/10 rounded-full blur-3xl group-hover:bg-gold-primary/20 transition-colors duration-500" data-id="element-16" />

                <h4 className="font-serif text-4xl sm:text-5xl text-gold-primary mb-6 relative" data-id="element-17">
                  {brand.name}
                </h4>

                <div className="w-full h-px bg-gold-gradient opacity-40 mb-6" data-id="element-18" />

                <ul className="space-y-3 relative" data-id="element-19">
                  {brand.models.map(model => <li key={model} className="flex items-center text-warm-gray font-medium text-sm" data-id="element-20">
                      <span className="text-gold-primary mr-3 text-xs" data-id="element-21">●</span>
                      {model}
                    </li>)}
                </ul>
              </div>
            </div>)}
        </div>

        {/* CTA Button */}
        <div className="text-center" data-id="element-22">
          <a href="#contact" className="inline-flex items-center justify-center gap-3 px-8 py-4 bg-brand-red text-white font-bold uppercase tracking-widest text-sm rounded hover:bg-red-700 hover:shadow-red-glow transition-all duration-300" data-id="element-23">
            {language === 'en' ? 'I Want This Car →' : 'Quiero Este Auto →'}
          </a>
        </div>
      </div>
    </section>;
}